import React from 'react';
import useStyles from './Content.styles';
import classNames from 'classnames';

export default function ({component = 'div', className, children}) {
    let classes = useStyles({component});

    return React.createElement(component, {
        className: classNames(classes['root'], className),
    }, children);
}
